import { render } from "./DenOfRobbers.vue?vue&type=template&id=ab11be24"
import script from "./DenOfRobbers.vue?vue&type=script&lang=js"
export * from "./DenOfRobbers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/DenOfRobbers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab11be24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab11be24', __exports__)) {
    api.reload('ab11be24', __exports__)
  }
  
  module.hot.accept("./DenOfRobbers.vue?vue&type=template&id=ab11be24", () => {
    api.rerender('ab11be24', render)
  })

}


export default __exports__